module.exports = __webpack_public_path__ + "img/pickThree.0e5877f5.webp";